import { API_BASE_URL, HEADERS_WITH_TOKEN } from 'services/api/BaseUrl'

export const getAll = (company = "") =>
  fetch(
    `${API_BASE_URL}/companies?data_id=${company}`,
    {
      method: 'GET',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  .then(res => res.json())


export const save = async (params) => {
  const res = await fetch(
    `${API_BASE_URL}/companies`,
    {
      method: 'POST',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const edit = async (data) => {
  const { id, params } = data
  const res = await fetch(
    `${API_BASE_URL}/companies/${id}`,
    {
      method: 'PUT',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk')),
      body: JSON.stringify(params)
    }
  )
  return await res.json()
}

export const remove = async (id) => {
  const res = await fetch(
    `${API_BASE_URL}/companies/${id}`,
    {
      method: 'DELETE',
      headers: HEADERS_WITH_TOKEN(localStorage.getItem('mqadtk'))
    }
  )
  return await res.json()
}